module.exports = "<span class=\"table-action-bar-selected\">\n  {{ itemsLength }} {{ 'TABLE_ACTION_BAR.ITEMS_SELECTED' | translate }}\n</span>\n"